import { render, staticRenderFns } from "./dashboard_page.vue?vue&type=template&id=330fa3be&scoped=true"
import script from "./dashboard_page.vue?vue&type=script&lang=js"
export * from "./dashboard_page.vue?vue&type=script&lang=js"
import style0 from "./dashboard_page.vue?vue&type=style&index=0&id=330fa3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330fa3be",
  null
  
)

export default component.exports